<template lang="pug">
.flow-left
	h1.mb-3 {{contentpage.name}}
	ws-content(:value="contentpage.content")
		template(slot="skitips")
			tips-tricks-list(:items="tipsByType('ski')")
		template(slot="snowboardtips")
			tips-tricks-list(:items="tipsByType('snowboard')")

</template>

<style lang="scss">
.play-btn:after {
	background: rgba(22, 25, 39, 0.2)
		url(https://static.wintersport.nl/images/video-play.png) no-repeat 50%;
	background-size: 20%;
}
</style>
<script>
import gql from 'graphql-tag';
import TipsTricksList from '@/components/tips-tricks-list.vue';
import MetaFragment from '@/components/graphql/metaFragment.graphql';
import Content from '@dengl/common/components/content.vue';

const query = gql`
	query getTipsAndTricksIndex($path: String!) {
		contentpage(path: $path) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			...MetaFragment
		}
		tipstricks {
			title
			slug
			type
			content {
				introduction
			}
			video {
				thumb
			}
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/tips-en-tricks',
			'nl-BE': '/tips-en-tricks'
		}
	},
	components: { TipsTricksList },

	asyncData({ _params, app, error }) {
		return app.$graphClient
			.query({
				query: query,
				variables: {
					path: '/tips-en-tricks'
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (errors) {
					throw errors[0];
				}

				if (!data.contentpage) {
					return error({ statusCode: 404, message: 'Page not found' });
				}

				app.meta(data.contentpage.meta);
				app.ads({ sidebar: { visible: true } });
				app.breadcrumbs({
					[app.i18n.t('page.videos:breadcrumb')]: { name: 'videos' },
					[app.i18n.t('page.videos.breadcrumb:tips.tricks')]: {
						name: 'videos-tipstricks'
					}
				});

				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'videos-tipstricks-index-01', error);
			});
	},
	methods: {
		tipsByType(type) {
			return this.tipstricks
				.filter(tip => tip.type === type)
				.map(tip => {
					tip.url = this.localePath({
						name: 'videos-tipstricks-slug',
						params: { slug: tip.slug }
					});

					return tip;
				});
		}
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
